import React, { useCallback, useRef, useEffect, useState } from 'react'
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import VisibilitySensor from 'react-visibility-sensor';
import { classNames } from '../functions/classNames';

const useStyles = (gray, white) => makeStyles((theme) => ({
    numb: {
        fontSize: 155,
        lineHeight: '0.8 !important',
        color: theme.palette.secondary.main,
        '-webkit-text-fill-color': gray ? theme.palette.gray.main : theme.palette.white.main,
        '-webkit-text-stroke-width': '2px',
        '-webkit-text-stroke-color': white ? theme.palette.white.main :  theme.palette.secondary.main,
        fontWeight: 700,
        [theme.breakpoints.down('xs')]: {
            fontSize: 100,
        },
    }
}));


const BigNumComponent = ({ showEl, white, gray, number, defaultNumb = 10, disableZero, className = '', speed = 100 }) => {
    const timer = useRef()
    const [numb, setNumb] = useState(defaultNumb);
    const [doAnim, setDoAnim] = useState(false);
    const classes = useStyles(gray, white)();
    useEffect(() => {
        if (doAnim) {
            let current = numb;
            timer.current = setInterval(function () {
                current -= 1;
                setNumb(`${disableZero ? '' : '0'}${current}`);
                if (current <= number) {
                    clearInterval(timer.current);
                    setDoAnim(false);
                }
            }, speed);
        }
        return () => {
            clearInterval(timer.current);
            timer.current = null;
        }
        // eslint-disable-next-line
    }, [doAnim])
    const onChange = useCallback((visible) => {
        if (visible && !doAnim && numb > number ){
            setDoAnim(true)
        }
    }, [doAnim, number, numb])
    return (
        <VisibilitySensor onChange={onChange}>
            <Typography variant='body2' className={classNames([classes.numb, className])} >{numb}{showEl ? showEl : ''}</Typography>
        </VisibilitySensor>
    )
}


export default React.memo(BigNumComponent);